var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPolizasInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#8a8a8a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_35",
    "data-name": "Capa 35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 23,
    height: 23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.9,1.41a.93.93,0,0,0-.8,0L3.65,4.72a1.07,1.07,0,0,0-.65,1v5a11.49,11.49,0,0,0,8.22,11,1.06,1.06,0,0,0,.56,0,11.49,11.49,0,0,0,8.22-11v-5a.94.94,0,0,0-.55-.85Zm6.33,4.47a.43.43,0,0,1,.25.38v4.4a10,10,0,0,1-7,9.53,10,10,0,0,1-7-9.53V6.59a.91.91,0,0,1,.54-.84L11.3,3a.47.47,0,0,1,.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.53,11.47a8.83,8.83,0,0,0,0-.89V5.23L11.5,1.66v9.81h8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.5,19.45V11.5h-8a11.09,11.09,0,0,0,8,9.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPolizasInactive);
export default __webpack_public_path__ + "static/media/ic-polizas-inactive.99fd1f9fe08846b724aca09c50eed6e4.svg";
export { ForwardRef as ReactComponent };